import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
  TextField,
  Divider,
  MenuItem,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

export default function ModalDeFiltros({
  open,
  onClose,
  onApply,
  filtros,
  setFiltros,
  showToast,
  showResumenOption = true,
}) {
  const [draft, setDraft] = useState(filtros);

  const today = new Date().toISOString().split("T")[0]; // Esto es para limitar el calendario a la fecha de hoy

  useEffect(() => {
    setDraft(filtros);
  }, [filtros]);

  const handleChange = (field, value) => {
    setDraft((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApply(draft);
    showToast("Filtros aplicados correctamente");
    onClose();
  };

  const handleClear = () => {
    const clean = {
      estado: null,
      tipos: [],
      soloPendientesDeAplicar: false,
      fechaInicio: null,
      fechaFin: null,
      ordenarDatos: "DESC",
      resumenesConDetalles: null,
    };
    setDraft(clean);
    setFiltros(clean);
    showToast("Filtros eliminados correctamente");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: "primary.main", color: "white" }}>
        <Box display="flex" alignItems="center" gap={2}>
          <FilterListIcon />
          <Typography variant="h6">Filtros</Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {/* CHECKS */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">
              Tipos de comprobante
            </Typography>

            {[
              "Factura",
              "Recibo",
              "Nota de credito",
              "Nota de debito",
              "Ajuste ctacte",
            ].map((tipo) => (
              <FormControlLabel
                key={tipo}
                control={
                  <Checkbox
                    checked={draft.tipos?.includes(tipo)}
                    onChange={(e) => {
                      const newTipos = e.target.checked
                        ? [...(draft.tipos || []), tipo]
                        : draft.tipos.filter((t) => t !== tipo);

                      handleChange("tipos", newTipos);
                    }}
                  />
                }
                label={tipo}
              />
            ))}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Estado"
              value={draft.estado || ""}
              onChange={(e) => handleChange("estado", e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="APROBADO">Aprobados</MenuItem>
              <MenuItem value="ANULADO">Anulados</MenuItem>
            </TextField>

            <Grid item xs={12} sx={{ my: 1.5 }}>
              <Divider />
            </Grid>

            <FormControlLabel
              control={
                <Checkbox
                  checked={draft.soloPendientesDeAplicar}
                  onChange={(e) =>
                    handleChange("soloPendientesDeAplicar", e.target.checked)
                  }
                />
              }
              label="Pendientes de aplicar"
            />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          {/* FECHAS */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Fecha inicio"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={draft.fechaInicio || ""}
              onChange={(e) => handleChange("fechaInicio", e.target.value)}
              inputProps={{ max: today }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Fecha fin"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={draft.fechaFin || ""}
              onChange={(e) => handleChange("fechaFin", e.target.value)}
              inputProps={{
                max: today,
                min: draft.fechaInicio !== null ? draft.fechaInicio : null,
              }}
            />
          </Grid>

          {/* ORDEN */}
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Ordenar"
              value={draft.ordenarDatos}
              onChange={(e) => handleChange("ordenarDatos", e.target.value)}
            >
              <MenuItem value="ASC">Ascendente</MenuItem>
              <MenuItem value="DESC">Descendente</MenuItem>
            </TextField>
          </Grid>
          {showResumenOption && (
            <>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">
                  Resumen
                </Typography>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={draft.resumenesConDetalles || false}
                      onChange={(e) =>
                        handleChange("resumenesConDetalles", e.target.checked)
                      }
                    />
                  }
                  label="Incluir detalles en el resumen"
                />
              </Grid>
            </>
          )}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ bgcolor: "grey.50", px: 3, py: 2 }}>
        <Button onClick={handleClear} color="warning">
          Limpiar
        </Button>

        <Box sx={{ flex: 1 }} />

        <Button variant="outlined" onClick={onClose} startIcon={<CloseIcon />}>
          Cancelar
        </Button>

        <Button variant="contained" onClick={handleApply}>
          Aplicar filtros
        </Button>
      </DialogActions>
    </Dialog>
  );
}
